class CreateUserNotify {
  static getEmailData = (dst, user) => {
    const from = `Gobierno de El Salvador <info@goes.gob.sv>`;

    const to = dst;
    const subject = `Usuario ${user?.displayName} solicita acceso al Portal`;
    const body = templeteData(user);

    return {
      from,
      to,
      subject,
      body
    };
  };
}

export default CreateUserNotify;

const templeteData = (user) => {
  return `
    <h2 style="text-align: center;">
      Solicitud de acceso al Portal de Proyectos Gobierno de El Salvador
    </h2>
    <br />
    <p>Estimado(a) Administrador,</p>
    <br />
    <p>
      Queremos informarte que usuario <strong>${user?.displayName}</strong> del <strong>${
    JSON.parse(user?.reloadUserInfo?.customAttributes).dependence
  }</strong>, esta solicitando acceso al portal de proyectos del Gobierno de El Salvador.</p>
    <br />
      <p> 
        <h3>Datos del usuario.</h3>
        <p><strong>Nombre completo:</strong> ${user?.displayName}</p>
        <p><strong>Dependencia:</strong> ${JSON.parse(user?.reloadUserInfo?.customAttributes).dependence}</p>
        <p><strong>Email:</strong> ${user?.email}</p>
        <p><strong>Telefono de contacto:</strong> ${user?.phoneNumber}</p>
      </p>
    <br />
    <p>
      Revisa la lista de usuarios pendientes de autorización en <a href="${'https://portal.modernizacion.gob.sv'}">aquí</a>, te estaremos informando acerca de mas solicitudes.
    </p>
    <br />
    <br />
    <p>Saludos,</p>
    <br />
    <p>Portal de Proyectos Gobierno de El Salvador en Convenio con Google LLC</p>
  `;
};
